import React from 'react';
import { Link } from 'react-router-dom';
import './style.scss';

const NotFound = () => (
  <div className="not-found-container container">
    <h2 className="not-found-title">Page Not Found</h2>
    <p className="not-found-message">
      The page you're looking for doesn't exist.
    </p>
    <Link to="/search" className="not-found-link">Search the Catalog</Link>
  </div>
);

export default NotFound;
